import { fromJS } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: null,
    errorMessage: '',
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SUMMARY_FETCH:
      return state.merge(reduxHelper.applyRequestInfo());
    case types.SUMMARY_FETCH_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          data: action.payload,
        })
      );
    case types.SUMMARY_FETCH_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
